import * as actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import getDefaultState from "./state";

export default {
  namespaced: true,
  state: Object.assign({}, getDefaultState()),
  actions,
  mutations,
  getters
};
